import { render, staticRenderFns } from "./BulkCloseConfirmDialog.vue?vue&type=template&id=6f7ebc4e"
import script from "./BulkCloseConfirmDialog.vue?vue&type=script&lang=js"
export * from "./BulkCloseConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports